/**
 * 点卡
 */
export interface iPointsCard {
  id: number;
  pos: number;
  price: number;
  original_price: number;
  amount: number;
  corner_label: string;
  original_price_desc: string;
  is_first_pay: boolean;
  is_default: boolean;
  desc1: string;
  desc2: string;
  client: number;
  pay_desc?: string;
  google_product_id?: string;
}

/**
 * 月卡/周卡
 */
export interface iPeriodCard {
  id: number;
  title: string;
  theme: number;
  price: number;
  amount: any;
  valid_days: number;
  price_desc: string;
  original_price_desc: string;
  is_default: boolean;
  color: any;
  client: number;
}
/* 标签配置 */
export interface iLableSetting {
  id: Number;
  idx: string;
  cases: string;
  text: string;
  version: Number;
  label: string;
  placeholder: string;
  maxlength: Number;
}

export interface gradeItem {
  grade: number;
  name: string;
}

export enum ELabeSetting {
  /* 主页“购买”标签 */
  PRICE_BUY_LABLE = 'price_buy_lable',
  /* 周期卡”标签 */
  PRICE_WEEK_LABLE = 'price_week_lable',
  /* 价格管理 */
  PRICE_MNANGE = 'price_manage',
}

export interface shortGoodsItem {
  id: number;
  type: number;
  name: string;
}
/**
 * 云朵
 */
export interface iCloudRecharge {
  id: number;
  value: number | null;
  price: number | null;
  desc: string;
  check: boolean;
}
